import { roundNumberAndDecimals } from '@teinor/erp/prices'
import { totalCalculateParams } from '@teinor/erp/prices/quote/calculate'
import { sellTicketStatusInversed } from '@teinor/erp/types/company/order/sell/sellTicket'
import { useCallback } from 'react'
import ModalSmallFilled from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { TPVOrderData } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/types'
import { twinFetchPostJSON } from '../../../../../../../../../../utils/globals/data'
import { SetEditDeleteModalTy } from '../../../../../../../../../../utils/hooks/useEditDeleteModal'
import useIsLoading from '../../../../../../../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { getPaymentTypes } from '../../../../../../../../../../utils/reducers/getters'

interface ModalDeliverSellTicketPartialChargedProps extends ModalDeliverSellTicketPartialChargedLogicProps {
}

const ModalDeliverSellTicketPartialCharged: React.FC<ModalDeliverSellTicketPartialChargedProps> = ({ setOpened, ...rest }) => {
    const { t } = useTwinTranslation()
    const { handleChargeSellTicketPartial, loading } = useModalDeliverSellTicketPartialChargedLogic({ setOpened, ...rest })
    return (
        <ModalSmallFilled opened={true} setOpened={() => { }} onCancel={() => rest.setOpenModal(null)} onAccept={handleChargeSellTicketPartial} translations={{
            title: t('sureDeliverthisTicket', '¿Seguro que quieres marcar como entregado este ticket?'),
            subtitle: t('itWillChangeStatusAsDelivered', 'Se marcará el ticket como entregado'),
            buttonAccept: t('accept', 'Aceptar'),
        }} className='text-gray-51' loading={loading} />
    )
}

interface ModalDeliverSellTicketPartialChargedLogicProps extends ModalEditComponentProps {
    setOpenModal: SetEditDeleteModalTy
    completeData: TPVOrderData
}

const useModalDeliverSellTicketPartialChargedLogic = ({ setOpenModal, completeData }: ModalDeliverSellTicketPartialChargedLogicProps) => {
    const { startLoading, endLoading, loading } = useIsLoading()
    const paymentTypes = getPaymentTypes()
    const handleChargeSellTicketPartial = useCallback(async () => {
        startLoading?.()
        const result = await twinFetchPostJSON('/api/app/order/tpv/sellTicket/updateSellTicket', { id: completeData?.header?.id, status: sellTicketStatusInversed['accepted']})
        if (result) {
            const myPaymentMethodInfo = []
            for (const element of completeData?.header?.CashRegisterMoneys || []) {
                let total = 0
                for (const log of element.CashRegisterMoneyLogs) {
                    total = total + parseFloat(String(log.money))
                }
                myPaymentMethodInfo.push({ ...paymentTypes?.all[element.PaymentTypeId], quantity: roundNumberAndDecimals(total, totalCalculateParams) })
            }
            setOpenModal({ type: 'delete', allRowData: { paymentMethodInfo: myPaymentMethodInfo, CurrencyId: completeData?.header?.CurrencyId, headerData: completeData?.header, OrderId: completeData?.header?.id, myTotalPayments: { total: completeData?.header?.total_payed } }})
        }
        endLoading?.()
    }, [completeData, startLoading, endLoading, setOpenModal, paymentTypes])

    return { handleChargeSellTicketPartial, loading }
}


export default ModalDeliverSellTicketPartialCharged